import { View, Text, TouchableOpacity, Pressable, ActivityIndicator, StyleSheet } from 'react-native'
import { fontPalette, globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../../components/home/HomeDetailsHeader'
import Card from '../../../components/shared/card/Card'
import CardSeparator from '../../../components/shared/card/CardSeparator'
import moment from 'moment'
import { useEffect, useMemo, useState } from 'react'
import { useLabourStore } from '../../../stores/labour'
import { useHomeStore } from '../../../stores/home'
import { useclockstore } from '../../../stores/clock'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { convertTo12HourTime, getLocalTimeWithTimezoneOffset } from '../../../utils'
import Toast from 'react-native-toast-message'
import { getCurrentLocationAndCheckQuadrilateral } from '../../../helpers/geoFencingHelper'
import { useTranslation } from 'react-i18next'
import { usePersonalStore } from '../../../stores/personalInfo'
import { Loading } from '../../../components/shared/navigator/Loading'
import ScreenStatus from '../../../components/home/ScreenStatus'


const Takebreak = ({ navigation, route }) => {
  const { params } = route
  const {
    mostRecentUserOnBoardings: userId,
    relationships,
    handlebreak,
    shiftid,
    breakType
  } = params
  const { t } = useTranslation()
  const labourStore = useLabourStore()
  const homestore = useHomeStore()
  const clockstore = useclockstore()
  const personalstore = usePersonalStore()
  const [currentTime, setCurrentTime] = useState(new Date())
  const [loader, setLoader] = useState(false)
  const [selectedDepartment, setSelectedDepartment] = useState<any>(null)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date())
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const shiftdetails = useMemo(() => {
    return labourStore.scheduleData?.shiftInfo?.find((item: any) => item.shiftID == shiftid)
  }, [labourStore.scheduleData, shiftid])


  useEffect(() => {
    clockstore.fetchattendancelogkey(
      userId,
      shiftid,
      labourStore?.labourData?.employeeNumber,
      labourStore?.labourData?.userId ? labourStore?.labourData?.userId : 0
    )
    clockstore.fetchdepartments(
      personalstore?.personalData?.entityId,
      homestore?.homeData?.laborSaverStoreID,
      labourStore?.labourData?.userId ? labourStore?.labourData?.userId : 0
    )
  }, [])

  useEffect(() => {
    const selectedDepartmentDetails = clockstore?.departmentsData?.data?.find((item) => item.department_Focus == clockstore?.departmentsData?.currentFocusDepartmentId);
    setSelectedDepartment(selectedDepartmentDetails)
  }, [clockstore?.departmentsData?.data, clockstore?.departmentsData?.currentFocusDepartmentId])


  const data = {
    EssUserOnboardingKey: userId,
    attendanceLogKey: clockstore.attendancelogkey,
    outType: 'BREAK_START',
    Dept_focus: selectedDepartment?.department_Focus,
    Dept_LaborSaver: selectedDepartment?.department_Laborsaver,
    satisfaction: '5',
    clockPunchTime: new Date().toISOString()
  }
  const data2 = {
    EssUserOnboardingKey: userId,
    attendanceLogKey: clockstore.attendancelogkey,
    outType: 'MEAL_START',
    Dept_focus: selectedDepartment?.department_Focus,
    Dept_LaborSaver: selectedDepartment?.department_Laborsaver,
    satisfaction: '5',
    clockPunchTime: new Date().toISOString()
  }

  const handleSubmit = async (outType: string) => {
    // const flag =
    //   !homestore.homeData?.geofencingStatus &&
    //   homestore.homeData?.coordinateOneLatitude != null
    // if (flag) {
    //   const topLeft = [
    //     homestore.homeData.coordinateOneLatitude,
    //     homestore.homeData.coordinateOneLongitude
    //   ]
    //   const topRight = [
    //     homestore.homeData.coordinateTwoLatitude,
    //     homestore.homeData.coordinateTwoLongitude
    //   ]
    //   const bottomRight = [
    //     homestore.homeData.coordinateThreeLatitude,
    //     homestore.homeData.coordinateThreeLongitude
    //   ]
    //   const bottomLeft = [
    //     homestore.homeData.coordinateFourLatitude,
    //     homestore.homeData.coordinateFourLongitude
    //   ]
    //   try {
    //     setLoader(true)
    //     const empLocation = null
    //     const res = await getCurrentLocationAndCheckQuadrilateral(
    //       topLeft,
    //       topRight,
    //       bottomLeft,
    //       bottomRight,
    //       empLocation
    //     )
    //     if (res) {
    //       try {
    //         handlebreak(true)
    //         AsyncStorage.setItem('Breaktype', outType)
    //         if (outType == 'BREAK_START') {
    //           await clockstore.updateclockin(data)
    //           navigation.navigate('LabourScreen')
    //         } else {
    //           await clockstore.updateclockin(data2)
    //           navigation.navigate('LabourScreen')
    //         }
    //       } catch (error) { }
    //       console.log('Location in inside')
    //     } else {
    //       Toast.show({
    //         type: 'error',
    //         position: 'bottom',
    //         text1: t('Cannot submit Clock In from outside the store'),
    //         visibilityTime: 5000,
    //         autoHide: true,
    //         topOffset: 60
    //       })
    //     }
    //   } catch (error) {
    //     console.log(error)
    //   } finally {
    //     setLoader(false)
    //   }
    // } else {
    try {
      handlebreak(true)
      AsyncStorage.setItem('Breaktype', outType)
      if (outType == 'BREAK_START') {
        await clockstore.updateclockin(data)
        navigation.navigate('LabourScreen')
      } else {
        await clockstore.updateclockin(data2)
        navigation.navigate('LabourScreen')
      }
    } catch (error) { }
    //   }
  }

  const formattedTime = currentTime.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  })

  const shiftTimeDisplay = useMemo(() => {
    if (!shiftdetails) return "";

    try {
      const date = moment(shiftdetails.date).format('MMM D');
      const start = convertTo12HourTime(shiftdetails.time_In);
      const end = convertTo12HourTime(shiftdetails.time_Out);
      return `${date}, ${start} - ${end}`;
    } catch (e) {
      return ("");
    }
  }, [shiftdetails]);



  if (clockstore?.loading) return <Loading />



  return (
    <>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader />
        </View>
        <View style={[globalStyles.vCenterItems]}>
          <Text
            style={[
              globalStyles.text,
              globalStyles.fwBold,
              globalStyles.fs30,
              globalStyles.whiteTextColor,
              globalStyles.textCenter
            ]}
          >
            {breakType === 'MEAL_START' ? t('Take a Meal Break') : t('Take a Break')}
          </Text>
          <TouchableOpacity
            style={{
              marginTop: 20,
              borderRadius: 5,
              backgroundColor: '#4FC7E8',
              width: '90%'
            }}
            onPress={() => navigation.navigate('LabourScreen')}
          >
            <Text
              style={{
                color: 'white',
                fontSize: 20,
                textAlign: 'center',
                padding: 10,
                fontFamily:fontPalette.primaryBold
              }}
            >
              {t('cancel')}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
      <View
        style={{
          marginTop: -44,
          padding: 16,
          flex: 1,
          justifyContent: 'space-between'
        }}
      >
        <Card>
          <View>
            <Text style={{ fontSize: 30, fontWeight: 'bold' ,fontFamily:fontPalette.primaryRegular}}>
              {formattedTime}
            </Text>
            <CardSeparator />
            <Text
              style={[
                globalStyles.inputLabel,
                globalStyles.inputLabelLarge,
                globalStyles.inputLabelPrimary,
              ]}
            >
              {t('Scheduled Shift')}
            </Text>
            <Text style={styles.clockText} >{shiftTimeDisplay}</Text>
            <View style={[{ width: '100%', marginRight: '2%' }]}>
              <Text
                style={[
                  globalStyles.inputLabel,
                  globalStyles.inputLabelLarge,
                  globalStyles.inputLabelPrimary,
                  { marginTop: 10 }
                ]}
              >
                {t('store')}
              </Text>

              <Text style={{ fontSize: 18,fontFamily:fontPalette.primaryRegular }}>
                {homestore?.homeData?.storeName}
              </Text>
            </View>

            <View style={[{ width: '100%', marginRight: '2%' }]}>
              <Text
                style={[
                  globalStyles.inputLabel,
                  globalStyles.inputLabelLarge,
                  globalStyles.inputLabelPrimary,
                  { marginTop: 10 }
                ]}
              >
                {t('Department')}
              </Text>

              <Text style={{ fontSize: 18,fontFamily:fontPalette.primaryRegular }}>
                {/* {homestore?.homeData?.deptName} */}
                {selectedDepartment?.depName}
              </Text>
            </View>
          </View>
        </Card>
        <View>
          {(breakType === 'BREAK_START') && (
            <TouchableOpacity
              style={{
                marginTop: 20,
                borderRadius: 5,
                backgroundColor: '#9DD086',
                width: '90%',
                alignSelf: 'center'
              }}
              onPress={() => {
                handleSubmit('BREAK_START')
              }}
            >
              <Text
                style={{
                  color: 'white',
                  fontSize: 20,
                  textAlign: 'center',
                  padding: 10,
                  fontFamily:fontPalette.primaryBold
                }}
              >
                {t('Take a Break')}
              </Text>
            </TouchableOpacity>
          )}
          {(breakType === 'MEAL_START') && (
            <TouchableOpacity
              style={{
                marginTop: 20,
                borderRadius: 5,
                backgroundColor: '#9DD086',
                width: '90%',
                alignSelf: 'center'
              }}
              onPress={() => {
                handleSubmit('MEAL_START')
              }}
            >
              <Text
                style={{
                  color: 'white',
                  fontSize: 20,
                  textAlign: 'center',
                  padding: 10,
                  fontFamily:fontPalette.primaryBold
                }}
              >
                {t('Take a Meal Break')}
              </Text>
            </TouchableOpacity>
          )}
        </View>
      </View >

    </>
  )
}
export default Takebreak

const styles = StyleSheet.create({
  clockText: {
    fontSize: 18,
    fontFamily:fontPalette.primaryRegular
  }
})